import {$KTM, KeyMetadatas} from "../shared/types";

export enum Codabot {
  RED = "red",
  YELLOW = "yellow",
  BLUE = "blue",
  GREEN = "green",
}

export type CodabotMetadata = {
  text: string,
  spriteImageUrl: string,
  spriteIconUrl: string,
}

export const CODABOT_KTM = new KeyMetadatas<CodabotMetadata>([
  $KTM(Codabot.RED, {
    text: "Red",
    spriteImageUrl: "/assets/codabot/red.png",
    spriteIconUrl: "/assets/codabot/red_icon.png"
  }),
  $KTM(Codabot.YELLOW, {
    text: "Yellow",
    spriteImageUrl: "/assets/codabot/yellow.png",
    spriteIconUrl: "/assets/codabot/yellow_icon.png"
  }),
  $KTM(Codabot.BLUE, {
    text: "Blue",
    spriteImageUrl: "/assets/codabot/blue.png",
    spriteIconUrl: "/assets/codabot/blue_icon.png"
  }),
  $KTM(Codabot.GREEN, {
    text: "Green",
    spriteImageUrl: "/assets/codabot/green.png",
    spriteIconUrl: "/assets/codabot/green_icon.png"
  }),
])